export default "__VITE_PUBLIC_ASSET__38b247ce__"